// SWITCHING ON AN ELEVATION SWITCH CLEARS THE PAGE'S LEVEL FILTER.
//
// Owner, 2026-10-02: "Switching on clears the level filter." He was
// offered three ways to settle the two narrowings disagreeing - the cut
// wins for its own rows, the filter wins, or the switch clears the filter
// - and chose this one knowing it discards something he typed.
//
// WHY IT NEEDED SETTLING AT ALL: the page cut says "also show the untagged
// at this elevation" and the header filter says "only rows whose level is
// Level 1". An element admitted by its HEIGHT has no level NAME that can
// match, so the filter threw out the exact population the switch was
// turned on for - and 5,557 Generic Models carrying no level could never
// arrive however many switches were on.
//
// THE RULE IS HERE, NOT IN A CALLBACK, because a rule inside an onChange
// handler is a rule no test reaches - and the first version of this
// shipped with nothing asserting it: deleting the line that clears the
// filter left every suite green.

// Did this change turn an elevation switch ON? Only the transition
// matters: a cut that already had one on and is being edited for its reach
// must not clear the filter again, or every keystroke in the reach box
// would wipe something.
export function turnsElevationOn(prevCut, nextCut) {
  const on = (c) => !!(c && c.mode === "level" && (c.atElevation || c.untaggedAtElevation));
  return on(nextCut) && !on(prevCut);
}

// What the page should be written with, and what to say. Returns null when
// nothing needs clearing - which is the common case and must not produce a
// toast.
export function clearLevelFilter(prevCut, nextCut, pageFilters) {
  if (!turnsElevationOn(prevCut, nextCut)) return null;
  const levels = (pageFilters && Array.isArray(pageFilters.levels)) ? pageFilters.levels.filter(Boolean) : [];
  // NO FILTER, NOTHING TO SAY. Telling somebody you cleared something they
  // had not set is noise, and it would train them to ignore the message
  // that matters.
  if (!levels.length) return null;
  return {
    filters: { ...(pageFilters || {}), levels: [] },
    cleared: levels,
    // SAID AT THE MOMENT IT HAPPENS, naming what went. "Your filter was
    // cleared" without the value leaves a person unable to put it back by
    // hand - and it is not put back automatically, deliberately: "clears"
    // that secretly means "parks" is hidden state, and a filter restored
    // against a model whose levels have changed is a stale value nobody
    // asked for.
    message: `The page's level filter (${levels.join(", ")}) has been cleared, because showing what stands at an elevation and filtering by level name are two different questions. It is not put back when you switch this off.`,
  };
}
